import React from 'react';

export default function PriorityBadge({ priority }) {
  if (!priority) return null;
  return (
    <span className="badge" style={{
      background: priority.color + '15',
      color: priority.color,
    }}>
      {priority.name}
    </span>
  );
}
